module.exports = __webpack_public_path__ + "img/fa.cc872fab.svg";